/* eslint-disable @typescript-eslint/no-misused-promises */
import React from "react";

import { Form, Input, Select } from "antd";
import { omit } from "lodash-es";

import { IFormsProps } from "../../../types";
import FormFooter from "../FormFooter";

const Option = Select.Option;

interface IFormInputs {
    title: string;
    stage: string;
}

export default function UpdateContactStageForm({
    initialData,
    canDelete = true,
    onCancel,
    onSubmit,
    onDelete,
}: IFormsProps) {
    const [form] = Form.useForm();
    const initialValues = {
        title: initialData.label,
        stage: String(initialData?.stage ?? ""),
    };

    const sumbit = (data: IFormInputs) => {
        console.log(data);
        onSubmit({
            ...omit(data, ["title"]),
            label: data.title,
        });
    };

    return (
        <div className="form-layout">
            <Form layout="vertical" form={form} initialValues={initialValues} onFinish={sumbit}>
                <Form.Item
                    label="Action Name"
                    name="title"
                    rules={[{ required: true, message: "Action Name is required field" }]}
                >
                    <Input placeholder="Action Name" />
                </Form.Item>
                <Form.Item name="stage" label="Stage" rules={[{ required: true, message: "Stage is required field" }]}>
                    <Select placeholder="Select" allowClear showSearch optionFilterProp="children">
                        <Option value="1">Stage 1</Option>
                    </Select>
                </Form.Item>
                <FormFooter onCancel={onCancel} canDelete={canDelete} onDelete={onDelete} />
            </Form>
        </div>
    );
}
